export const REDUCER_NAME = "formStates";

export const ACTION_TYPES = {
  set: `${REDUCER_NAME}/set`,
  reset: `${REDUCER_NAME}/reset`,
};

// Unique signature to avoid key collisions in DB, location state and query params.
const SIG = "__fs4gh87";

export const LOCATION_STATE_KEY = `${SIG}_form_state`;

export const QUERY_PARAM_KEY = `${SIG}_recovered`;

export const QUERY_PARAM_KEY_VALUE = "true";

export const RECOVERED_QUERY_PARAM = `${QUERY_PARAM_KEY}=${QUERY_PARAM_KEY_VALUE}`;
